import { Trans } from 'react-i18next'

/**
 * Terms is a function component that displays a message about the terms of service and privacy policy.
 *
 * @param {Object} props - The component's props.
 * @param {string} props.className - A string to be applied as a CSS class to the component's main div.
 *
 * @returns {JSX.Element} A div element containing the terms of service and privacy policy message.
 */
function Terms({ className }: { className?: string }) {
  return (
    <div className={className}>
      <Trans i18nKey='signUpNote'>
        <span>By signing up, you agree to our you agree to our</span>
        &nbsp;
        <a className='link' href='#'>
          Terms of service
        </a>
        &nbsp;
        <span>and</span>
        &nbsp;
        <a className='link' href='#'>
          Privacy Policy
        </a>
      </Trans>
    </div>
  )
}

export default Terms
